import ModuleAccess from '@/graphql/ModuleAccess.gql'
import GetFinancialModules from '@/graphql/GetFinancialModules.gql'
import { createProvider } from '../../vue-apollo'

const apollo = createProvider()

export default {
  async getModuleAccess ({ dispatch }, { module }) {
    try {
      const result = await apollo.defaultClient.query({
        query: ModuleAccess,
        fetchPolicy: 'no-cache',
        variables: {
          module
        }
      })

      return result.data.ModuleAccess
    } catch (error) {
      dispatch('showError', error)
    }
  },
  // Módulos activos/licenciados de la financiera+usuario actual — si un módulo
  // no aparece en la respuesta, no está habilitado (el resolver ya filtra por
  // licencia/activación, no hay un campo isEnabled explícito que consultar).
  async getFinancialModules ({ commit, dispatch }) {
    try {
      const result = await apollo.defaultClient.query({
        query: GetFinancialModules,
        fetchPolicy: 'no-cache'
      })

      const modules = result.data.getFinancialModules || []
      commit('setEnabledFinancialModules', modules)
      return modules
    } catch (error) {
      dispatch('showError', error)
      return []
    }
  }
}
